export default {"src":"/_next/static/media/forbes.8e3cdfee.svg","height":32,"width":129,"blurWidth":0,"blurHeight":0};